import React from 'react'
import { ArrowLeftIcon } from 'assets/icons'
import { Auth } from 'services'
import { Button } from 'components'
import { Gtm } from 'helpers'
import { PAGE_TYPES } from 'src/constants'
import { Link } from 'react-router-dom'

interface Props {
    auth: Object
}

const auth = new Auth()

export default class Logout extends React.Component<Props> {

    public componentDidMount() {
        document.getElementsByTagName('html')[0].classList.add('page-product-detail')
        // GTM
        Gtm.pushPageType(PAGE_TYPES.LOGOUT)
        //  End GTM
    }

    public componentWillUnmount() {
        document.getElementsByTagName('html')[0].classList.remove('page-product-detail')
    }

    public handleClick = () => {
        // End GTM
        auth.logout()
    }

    public render() {
        return (
            <section className="page-layout">
                <header>
                    <a href="/search" className="button--link">
                        <ArrowLeftIcon fill="#000000"/>
                        Back
                    </a>
                </header>
                <main>
                    <h1 className="u-margin-top--md">Are you <br/> sure you want <br/>to logout?</h1>
                </main>
                <footer>
                    <Link to="/search" className="text-link u-text--centered">No, go back to overview</Link>
                    <Button full={true} className="u-margin-top--md" onClick={this.handleClick}>Yes, log me out</Button>
                </footer>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/Logout/index.tsx